import React from 'react'
import type { ILang } from '@src/interfaces'

import styles from './styles.module.scss'

interface ILanguageSelectorProps {
  defaultLang: ILang | undefined
  languages?: ILang[]
  children?: React.ReactNode
  onSelectedLang: (lang: ILang) => void
}

export const Languages = [
  { code: 'es', label: 'Español' },
  { code: 'en', label: 'Inglés' },
  { code: 'fr', label: 'Francés' },
  { code: 'pt', label: 'Portugués' },
  { code: 'de', label: 'Alemán' },
  { code: 'pl', label: 'Polaco' }
]

const LanguageSelector: React.FC<ILanguageSelectorProps> = ({
  defaultLang,
  languages = Languages,
  children,
  onSelectedLang
}) => {
  const handleSelectedLang = (lang: ILang) => {
    onSelectedLang(lang)
  }

  return (
    <div className='rankmiTemplates-languageSelector'>
      <ul className={`${styles.languageList}`}>
        {languages.map((language) => (
          <li
            key={language.code}
            onClick={() => {
              handleSelectedLang(language)
            }}
            className={language.code === defaultLang?.code ? styles.active : ''}
          >
            <span className='lang'>{language.label}</span>
          </li>
        ))}
      </ul>
      {children && <div className='languageSelector-container'>{children}</div>}
    </div>
  )
}

export default LanguageSelector
